function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.7 5.63l5.66 5.66a9 9 0 1 1-12.72 0l5.65-5.66a1 1 0 0 1 1.41 0zm-5.65 7.08a7 7 0 1 0 9.9 0L16 7.76z",
  fill: "#fff",
  "data-name": "Watermark"
});

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("title", null, title), _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHRpdGxlPk9ubGluZSBTY3JlZW5lcnMgV2F0ZXJtYXJrPC90aXRsZT4KICA8ZyBmaWxsPScjZmZmZmZmJyBpZD0iMWMyOGE4MTEtMWE4NS00OTRjLTg3MTgtZWFmZWMwY2YzZmJhIiBkYXRhLW5hbWU9IldhdGVybWFyayI+CiAgICA8cGF0aCBkPSJNMTYuNyw1LjYzbDUuNjYsNS42NmE5LDksMCwxLDEtMTIuNzIsMGw1LjY1LTUuNjZBMSwxLDAsMCwxLDE2LjcsNS42M1ptLTUuNjUsNy4wOGE3LDcsMCwxLDAsOS45LDBMMTYsNy43NloiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgComponent as ReactComponent };